import { ToastComponent } from './toast.component';
import { ToastService } from './toast.service';
import { Toast } from './models/toast';
import { listAnimation } from './list-animation';
import {
  ChangeDetectionStrategy,
  Component,
  computed,
  effect,
  inject,
  input,
} from '@angular/core';

@Component({
  imports: [ToastComponent],
  selector: 'mop-toast-outlet',
  host: {
    class: 'position-fixed',
    '[style]': 'hostStyle()',
  },
  template: `
    @if (toasts().length > 0) {
      <div
        class="d-flex flex-column gap-2 pe-none"
        [@listAnimation]="toasts().length"
      >
        @for (toast of toasts(); track $index) {
          <mop-toast
            class="pe-auto"
            [type]="toast.type"
            [title]="toast.title"
            [closable]="toast.closable"
            (close)="close(toast)"
          >
            <span [innerHTML]="toast.content"></span>
          </mop-toast>
        }
      </div>
    }
  `,
  animations: [listAnimation],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ToastOutletComponent {
  private readonly toastService = inject(ToastService);

  private readonly timeoutIds = new Map<Toast, number>();

  top = input('');
  right = input('');
  bottom = input('');
  left = input('');

  hostStyle = computed(() => {
    const styles: string[] = [
      'z-index: 1090',
      this.top() === ''
        ? this.bottom() === ''
          ? 'top: 0'
          : `bottom: ${this.bottom()}`
        : `top: ${this.top()}`,
      this.right() === ''
        ? this.left() === ''
          ? 'right: 0'
          : `left: ${this.left()}`
        : `right: ${this.right()}`,
    ];
    return styles.join('; ').trim();
  });

  toasts = this.toastService.toasts.asReadonly();

  constructor() {
    effect(() => {
      for (const toast of this.toastService.toasts()) {
        if (toast.autohide && !this.timeoutIds.has(toast)) {
          this.timeoutIds.set(
            toast,
            window.setTimeout(() => {
              this.timeoutIds.delete(toast);
              this.close(toast);
            }, toast.delay)
          );
        }
      }
    });
  }

  close(toast: Toast) {
    if (this.timeoutIds.has(toast)) {
      window.clearTimeout(this.timeoutIds.get(toast));
      this.timeoutIds.delete(toast);
    }
    this.toastService.remove(toast);
  }
}
